import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
const Root = styled.div.withConfig({
  displayName: "Card__Root",
  componentId: "sc-1y6dkcc-0"
})(["", " padding:var(--size-spacing-05);background-color:var(--color-white);border:1px solid var(--color-gray-20);border-radius:var(--border-radius-rounded);will-change:border-color,box-shadow;transition-property:border-color,box-shadow,background-color;transition-duration:var(--motion-duration-fast);transition-timing-function:var(--motion-timing-function-ease-out);", " ", ";"], ScopedCssBaseline, ({
  clickable
}) => clickable && css(["cursor:pointer;outline:none;&:hover{border-color:transparent;box-shadow:var(--shadow-sm);}"]), ({
  active
}) => active && css(["border-color:var(--color-primary-50);background-color:var(--color-primary-50);"]));
const Card = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    as,
    active,
    children,
    clickable,
    onClick
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["as", "active", "children", "clickable", "onClick"]);

  let clickableProps;

  if (clickable && onClick ? true : clickable) {
    clickableProps = {
      role: 'button',
      'aria-pressed': active,
      tabIndex: 0
    };
  }

  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref,
    as: as,
    active: active,
    clickable: clickable,
    onClick: onClick
  }, rest, clickableProps), children);
});
Card.displayName = 'Card';
Card.defaultProps = {
  clickable: false,
  active: false,
  as: 'div',
  children: null
};
process.env.NODE_ENV !== "production" ? Card.propTypes = {
  /**
   * Allows interaction in the component using defined styles as hover, focus, active
   */
  clickable: PropTypes.bool,

  /**
   * Sets the Card as active. This is useful within the interaction mode.
   */
  active: PropTypes.bool,

  /**
   * Sets the element type to be rendered for this component. By default, it will render a `<div>` element.
   */
  as: PropTypes.node,

  /**
   * Sets the children
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  onClick: PropTypes.func
} : void 0;
export default Card;